import React from 'react';
import { itemFilterTypes } from '../../../constants';
import FilterGroup from './filter-group';

const PublisherFilterGroup = ({ onApply }) => {
  const activeFilters = [
    itemFilterTypes.industryCpdCategory,
    itemFilterTypes.publisher,
    itemFilterTypes.status,
    itemFilterTypes.publisherGoal
  ]

  return <div id='publisher-filter-group'>
    <FilterGroup {...{
      publisherOnly: true,
      activeFilters,
      onApply
    }} />
  </div>
}

export default PublisherFilterGroup


// WEBPACK FOOTER //
// ./src/containers/components/filters/publisher-filter-group.js